<app-header [backButton]="false" containerType="container-fluid">
    <div headerBody class="d-flex flex-row justify-content-between mb-1 mt-1">
      <h1 class="display-3 line-height-1" translate>instructions.title</h1>

    </div>
  </app-header>
  <div class="container-fluid content-margin-top">
    <router-outlet></router-outlet>
  </div>
